import { z } from "zod";
import { BladeCommonSchema } from "../common";
import { BackdropSchema } from "../../fragments/Backdrop";
import { BladeHeaderSchema } from "../../../schemas/fragments/BladeHeader";
import { MediaPromoItemSchema } from "../../fragments/MediaPromoItem";
import { LinksGroupSchema } from "../../fragments/LinksGroup";
export const MediaPromoBladeTypeValues = ["mediaPromo", "centeredPromotion", "betaInviteMediaPromo"];
export const MediaPromoBladeTypesSchema = z.enum(MediaPromoBladeTypeValues);
export const MediaPromoBladeTypes = MediaPromoBladeTypesSchema.enum;
export const MediaPromoBladeSchema = BladeCommonSchema.extend({
    backdrop: BackdropSchema.optional(),
    header: BladeHeaderSchema.optional(),
    item: MediaPromoItemSchema.optional(),
    linksGroup: LinksGroupSchema.optional(),
});
export const MediaPromoBladesContractSchema = MediaPromoBladeSchema.extend({
    type: MediaPromoBladeTypesSchema,
});
export const MediaPromoBladeContractSchema = MediaPromoBladeSchema.extend({
    type: z.literal(MediaPromoBladeTypes.mediaPromo),
});
export const CenteredPromotionContractSchema = MediaPromoBladeSchema.extend({
    type: z.literal(MediaPromoBladeTypes.centeredPromotion),
});
export const BetaInviteMediaPromoContractSchema = MediaPromoBladeSchema.extend({
    type: z.literal(MediaPromoBladeTypes.betaInviteMediaPromo),
});
//# sourceMappingURL=index.js.map